import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

const useSentryReplay = ({ sessionName }: { sessionName: string }): void => {
  useEffect(() => {
    const replay = Sentry.getReplay();
    if (replay) {
      Sentry.setTag('sessionName', sessionName);
      replay.start();
    }
    return () => {
      if (replay) {
        replay.stop();
      }
    };
  }, [sessionName]);
};

export default useSentryReplay;
